<template>
  <v-card>
     <v-card-title>
       <v-icon x-large>mdi-lan-connect</v-icon>
       <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Filtro"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
    :headers="headers"
    :items="process"
    :search="search"
    sort-by="calories"
    class="elevation-1"
  >
    <template v-slot:top>
      <v-toolbar flat color="white">
        <v-spacer></v-spacer>
        <v-dialog v-model="dialog" max-width="900px">
          <!--<template v-slot:activator="{ on }">
            <v-btn color="primary" dark class="mb-2" v-on="on">New Item</v-btn>
          </template>-->
          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-form
                  ref="form"
                  v-model="valid"
                  lazy-validation
                >
                  <v-row>
                     <v-col cols="12" sm="6" md="12">
                      <v-text-field :disabled="true" v-model="editedItem.ApiProcess_id"
                        label="Proceso ID"  :counter="30" required></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="12">
                      <v-text-field v-model="editedItem.ApiProcess_Description" :rules="descRules" label="Proceso Descripcion"
                        :counter="50" required></v-text-field>
                    </v-col>
                  </v-row>
                </v-form>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="close">Cancel</v-btn>
              <v-btn :disabled="!valid" color="accent" text @click="save">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialog_new" max-width="900px">
          <template v-slot:activator="{ on }">
            <v-btn color="accent" dark class="mb-2" v-on="on">NUEVO PROCESO</v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-form
                  ref="form"
                  v-model="valid"
                  lazy-validation
                >
                  <v-row>
                     <v-col cols="12" sm="6" md="12">
                      <v-text-field v-model="editedItem.ApiProcess_id" :rules="idRules" label="Proceso ID"
                        :counter="30" required></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="12">
                      <v-text-field v-model="editedItem.ApiProcess_Description" :rules="descRules" label="Proceso Descripcion"
                        :counter="50" required></v-text-field>
                    </v-col>
                  </v-row>
                </v-form>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="close">Cancel</v-btn>
              <v-btn :disabled="!valid" color="accent" text @click="save">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>
    <template v-slot:item.action="{ item }">
      <v-icon
        small
        class="mr-2"
        @click="editItem(item)"
      >
        mdi-pencil
      </v-icon>
      <v-icon
        small
        @click="deleteItem(item)"
      >
        mdi-delete
      </v-icon>
    </template>
    <template v-slot:no-data>
      <v-btn color="accent" @click="initialize">Reset</v-btn>
    </template>
  </v-data-table>
  </v-card>
</template>

<script>
import axios from 'axios'
export default {
  data: () => ({
    search: '',
    api_tool_url: process.env.VUE_APP_API_TOOL_URL,
    dialog: false,
    dialog_pass: false,
    dialog_new: false,
    valid: true,
    headers: [
      { text: 'Proceso ID', value: 'ApiProcess_id' },
      { text: 'Proceso Descripcion', value: 'ApiProcess_Description' },
      { text: 'Actions', value: 'action', sortable: false }
    ],
    process: [],
    editedIndex: -1,
    editedItem: {
      ApiProcess_id: '',
      ApiProcess_Description: ''
    },
    defaultItem: {
      ApiProcess_id: '',
      ApiProcess_Description: ''
    },
    idRules: [
      v => !!v || 'Proceso ID es requerido',
      v => (v && v.length <= 30) || 'Proceso ID debe tener menos de 30 caracteres'
    ],
    descRules: [
      v => !!v || 'Proceso Descripcion es requerido',
      v => (v && v.length <= 61) || 'Proceso Descripcion debe tener menos de 30 caracteres'
    ],
    config: {
      headers: {
        //'Authorization': 'Bearer ' + sessionStorage.getItem('access_token'),
        "api-user": sessionStorage.getItem('ApiUser_id')
      }
    }
  }),

  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'Nuevo Proceso' : 'Editar Proceso'
    }
  },

  watch: {
    dialog (val) {
      val || this.close()
    }
  },

  created () {
    this.initialize()
  },

  methods: {
    initialize () {
      axios.post(this.api_tool_url + '/get_apiprocess', {}, this.config)
        .then(response => {
          this.process = response.data.ResultRows
        })
        .catch(error => {
          this.process = []
          alert(error.response.data.message)
        })
    },

    newtItem (item) {
      this.editedIndex = this.process.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog_new = true
    },

    editItem (item) {
      this.editedIndex = this.process.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },

    deleteItem (item) {
      const index = this.process.indexOf(item)
      confirm('Are you sure you want to delete this item?') && this.deleteProcess(index)
    },

    deleteProcess (index) {
      let userTmp = this.process[index]
      delete userTmp.ApiRole_Description
      axios.post(this.api_tool_url + '/del_apiprocess', userTmp, this.config)
        .then(response => {
          this.process.splice(index, 1)
          this.close()
        })
        .catch(error => {
          this.process = []
          alert(error.response.data.message)
        })
    },

    close () {
      this.dialog = false
      this.dialog_new = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },

    save () {
      if (this.editedIndex > -1) {
        axios.post(this.api_tool_url + '/upd_apiprocess', this.editedItem, this.config)
          .then(response => {
            Object.assign(this.process[this.editedIndex], response.data.ResultRows[0])
            this.close()
          })
          .catch(error => {
            this.process = []
            alert(error.response.data.message)
          })
      } else {
        axios.post(this.api_tool_url + '/ins_apiprocess', this.editedItem, this.config)
          .then(response => {
            this.process.push(response.data.ResultRows[0])
            this.close()
          })
          .catch(error => {
            this.process = []
            alert(error.response.data.message)
          })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ProcessGrid.vue